<template>
  <div>
    <van-nav-bar
      title="修改俱乐部"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">

      <van-field
        clearable
        v-model="ClubName"
        name="ClubName"
        label="俱乐部名"
        placeholder="俱乐部名"
        :rules="[{ required: true, message: '请填写俱乐部名' }]"
      />

      <van-field
        clearable
        v-model="Location"
        name="Location"
        label="俱乐部地点"
        placeholder="俱乐部地点"
        :rules="[{ required: true, message: '请填写俱乐部地点' }]"
      />

      <van-field
        readonly
        clickable
        :value="startTime"
        name="startUnixTime"
        label="选择时间"
        placeholder="点击选择俱乐部开始选择时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择俱乐部开放加入时间"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="tecnameandnum"
        :value="tecnameAndNumValue"
        label="负责教师"
        placeholder="点击选择负责教师"
        @click="tecnameshowPicker = true"
      />

      <van-popup class="popup" v-model="tecnameshowPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="getTecNameAndNum"
          @confirm="tecnameOnConfirm"
          @cancel="tecnameshowPicker = false"
        />
      </van-popup>

      <van-divider>学生管理员列表</van-divider>
      <van-cell-group inset>
        <van-cell v-for="(item,index) in admins" :title="item.sname+' '+item.snum" :key="index">
          <template #right-icon>
            <div style="color:#f40" @click="delAdmin(item.cid,item.sid)">删除</div>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="padding: 20px;text-align: center;font-weight: bolder;">
        <div @click="stuShow=true">添加学生管理员</div>
      </div>

      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>

      <van-field
        v-model="introduction"
        rows="2"
        autosize
        name="introduction"
        clearable
        label="简介"
        type="textarea"
        maxlength="500"
        placeholder="俱乐部简介"
        show-word-limit
        :rules="[{ required: true, message: '请填写俱乐部简介' }]"
      />

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          修改俱乐部
        </van-button>
      </div>

      <div style="padding: 30px"></div>
    </van-form>

    <van-action-sheet v-model="stuShow" title="学生搜索">
      <div class="classesContent">
        <van-search v-model="stuSearchKey" @search="stuSearch" placeholder="请输入姓名或学号搜索关键词"/>
        <van-cell-group inset>
          <van-cell
            :class="admins.filter(res=>res.sid==item.id).length!=0?'classesSelected':''"
            :title="item.sName" :value="item.sNum" v-for="(item,index) in students" @click="adminSelect(item)"
            :key="index"/>
        </van-cell-group>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import {getTeacherList} from "../../../network/teacher"
import {ModifyClub, GetClubInfoById, AddClubAdmin, GetClubAdminList, DelClubAdmin} from "../../../network/club"
import {
  getStuListLikeKeyByPage,
} from "@/network/student";
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  CellGroup,
  Cell,
  ActionSheet, Search, Toast, Divider
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(ActionSheet);
Vue.use(Search);
Vue.use(Toast);
Vue.use(Divider);
export default {
  name: "ModifyClub",
  data() {
    return {
      //Club Name
      ClubName: "",

      // 学生管理员列表
      admins: [],

      // 学生搜索 action sheet
      students: [],
      stuShow: false,
      stuSearchKey: "",

      //Club Location
      Location: "",

      //Maximum number of people
      maxp: 1,

      //Rush club time
      startTime: '',
      startTimeShowPicker: false,
      currentDate: new Date(),
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
      startUnixTime: '',

      //Teacher and Teacher`s number
      teachers: [],
      tecnameAndNumValue: '',
      tecnameshowPicker: false,
      columns: ['男', '女'],

      //Course introduction
      introduction: "",

      club_id: 0,
    }
  },
  created() {
  },
  activated() {
    GetClubAdminList(this.$route.query.id).then(res => {
      this.admins = res;
    })
    GetClubInfoById(this.$route.query.id).then(res => {
      this.club_id = res.id;
      this.ClubName = res.title;
      this.Location = res.location;
      this.startTime = new Date(parseInt(res.startTime)).toLocaleString();
      this.currentDate = new Date(parseInt(res.startTime));
      this.startUnixTime = res.startTime;
      this.maxp = res.maxp;
      // this.tecnameAndNumValue = this.teachers.filter(value => value.id == res.tId).map(value => value.id + ':' + value.tName + ':' + value.tNum + ':' + value.gender)[0];
      this.tecnameAndNumValue = res.tId + ':' + res.tName + ':' + res.tNum + ':' + res.tGender;
      this.introduction = res.des;
    });
    getTeacherList().then(res => {
      this.teachers = [];
      this.teachers.push(...res);
    });
  },
  computed: {
    getTecNameAndNum() {
      return this.teachers.map(value => value.id + ':' + value.tName + ':' + value.tNum + ':' + value.gender);
    }
  }
  ,
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      this.$router.replace("/club");
    },
    tecnameOnConfirm(value) {
      this.tecnameAndNumValue = value;
      this.tecnameshowPicker = false;
    },
    stuSearch() {
      getStuListLikeKeyByPage(this.stuSearchKey, 1).then(res => {
        this.students = res;
      })
    },
    adminSelect(stu) {
      AddClubAdmin(this.club_id, stu.id, stu.sName, stu.sNum).then(res => {
        if (res) {
          this.admins.push({cid: this.club_id, sid: stu.id, sname: stu.sName, snum: stu.sNum});
        }
      })
      this.stuShow = false;
    },
    onSubmit(values) {
      if (values.ClubName === "") {
        this.Dialoginfo('提示', '俱乐部名不能为空');
      } else if (this.Location === "") {
        this.Dialoginfo('提示', '俱乐部位置不能为空');
      } else if (values.introduction === "") {
        this.Dialoginfo('提示', '俱乐部简介不能为空');
      } else {
        Dialog.confirm({
          title: '警告',
          message: '确定要修改俱乐部吗'
        }).then(() => {
          let teacher = values.tecnameandnum.split(':');
          ModifyClub(this.club_id, values.ClubName, teacher[0], teacher[1], teacher[2], teacher[3], values.Location, values.introduction, this.maxp, this.startUnixTime).then(res => {
            if (res) {
              this.Dialoginfo('提示', '修改成功');
            } else {
              this.Dialoginfo('提示', '修改失败,俱乐部名称可能重复。');
            }
          });
          // on confirm
        }).catch(() => {
          // on cancel
        });

      }
    },
    delAdmin(cid, sid) {
      DelClubAdmin(cid, sid).then(res => {
        if (res) {
          this.admins = this.admins.filter(res => res.sid != sid)
        }
      })
    },
    startOnConfirm(value) {
      this.startUnixTime = value.getTime().toString();
      this.startTime = value.toLocaleString();
      this.startTimeShowPicker = false;
    },
  }
}
</script>

<style scoped>
.classesContent {
  padding: 16px 16px 360px;
}

.classesSelected {
  color: #7dbfff;
  font-weight: bold;
}
</style>
